import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-session-timeout-dialog',
  template: `
    <h2 mat-dialog-title>Session Timeout Warning</h2>
    <mat-dialog-content>
      <p>Your session will expire in <span class="countdown">0:{{ formattedCountdown }}</span> seconds due to inactivity.</p>
      <p>Do you want to continue your session?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onLogout()">Logout</button>
      <button mat-raised-button color="primary" (click)="onContinue()">Continue Session</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 300px;
    }
    .countdown {
      font-weight: bold;
      color: #f44336;
    }
  `]
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {
  countdown: number;
  private countdownSubscription: Subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { remainingTime: number }
  ) {
    this.countdown = this.data.remainingTime;
  }

  get formattedCountdown(): string {
    // Add leading zero for single-digit seconds
    return this.countdown < 10 ? `0${this.countdown}` : `${this.countdown}`;
  }

  ngOnInit(): void {
    // Create a countdown timer that updates every second
    this.countdownSubscription = interval(1000)
      .pipe(take(this.data.remainingTime))
      .subscribe(() => {
        this.countdown--;

        // Close the dialog when countdown reaches 0
        if (this.countdown <= 0) {
          this.dialogRef.close(false);
        }
      });
  }

  ngOnDestroy(): void {
    // Clean up subscription when component is destroyed
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }

  onContinue(): void {
    this.dialogRef.close(true);
  }

  onLogout(): void {
    this.dialogRef.close(false);
  }
} 